import axios from "axios";

const axiosInstance = axios.create({
  // baseURL: "http://localhost:4000",
  baseURL: "https://api.fiscal-kids.com/",
});

export default axiosInstance;
